import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import { FieldError } from "react-hook-form";
import InputMask from "@mona-health/react-input-mask";
import Input from "../Input";

type SsnInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: ReactNode;
  error?: FieldError;
};

const SsnInput = forwardRef<HTMLInputElement, SsnInputProps>(
  ({ value, placeholder, onChange, error, label, ...rest }, ref) => {
    return (
      <div
        className={`relative flex flex-col`}
        key={`SSN-${rest.defaultValue}`}
      >
        <InputMask
          ref={ref}
          mask={"999-99-9999"}
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder ?? "xxx-xx-xxxx"}
          {...rest}
        >
          <Input error={error} label={label} />
        </InputMask>
      </div>
    );
  }
);

SsnInput.displayName = "SsnInput";

export default SsnInput;
